import React, { useState } from 'react';
import { Card, Form, Button, Alert } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { passwordRecoveryApiService } from '../services/apiServices';

const ForgotPasswordPage: React.FC = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await passwordRecoveryApiService.initRecovery(email);
      setSubmitted(true);
    } catch (err: any) {
      const body = err?.body as { code?: string; message?: string } | undefined;
      if (body?.code === 'user_not_found') {
        setError('Пользователь с таким email не найден');
      } else if (body?.code === 'password_auth_recovery_rate_limited') {
        setError('Слишком много запросов. Попробуйте позже');
      } else {
        setError(body?.message || 'Ошибка при отправке запроса на восстановление');
      }
    } finally {
      setLoading(false);
    }
  };

  if (submitted) {
    return (
      <Card className="shadow w-100" style={{ maxWidth: '400px', margin: '0 auto' }}>
        <Card.Header className="bg-primary text-white text-center py-3">
          <Card.Title className="mb-0">
            <h3 className="mb-0">Восстановление пароля</h3>
          </Card.Title>
        </Card.Header>
        <Card.Body className="p-4 text-center">
          <Alert variant="success">
            Если указанный email зарегистрирован в системе, на него будет отправлена ссылка для
            восстановления пароля.
          </Alert>
          <Link to="/login" className="btn btn-primary">
            Вернуться к входу
          </Link>
        </Card.Body>
      </Card>
    );
  }

  return (
    <Card className="shadow w-100" style={{ maxWidth: '400px', margin: '0 auto' }}>
      <Card.Header className="bg-primary text-white text-center py-3">
        <Card.Title className="mb-0">
          <h3 className="mb-0">Восстановление пароля</h3>
        </Card.Title>
      </Card.Header>
      <Card.Body className="p-4">
        {error && (
          <Alert variant="danger" className="mb-3">
            {error}
          </Alert>
        )}

        <p className="text-muted mb-3">
          Укажите email, указанный при регистрации. На него будет отправлена ссылка для смены
          пароля.
        </p>

        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-4" controlId="formEmail">
            <Form.Label className="fw-bold">Email</Form.Label>
            <Form.Control
              type="email"
              placeholder="Введите email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              disabled={loading}
              className="py-2"
            />
          </Form.Group>

          <Button
            variant="primary"
            type="submit"
            className="w-100 py-2 fw-semibold"
            disabled={loading}
          >
            {loading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                ></span>
                Отправка...
              </>
            ) : (
              'Отправить ссылку'
            )}
          </Button>
        </Form>

        <div className="text-center mt-3">
          <Link to="/login" className="text-decoration-none">
            Вернуться к входу
          </Link>
        </div>
      </Card.Body>
    </Card>
  );
};

export default ForgotPasswordPage;
